var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"px-4 py-2 border-2 font-bold uppercase transition-colors w-full sm:w-auto text-center",attrs:{"href":_vm.to,"target":"_blank","rel":"noopener noreferrer"}},[_c('span',{staticClass:"button-label"},[_vm._v(" ~ "+_vm._s(_vm.label)+" ~ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }